import img1 from './BannerImgSlider/Bannerimg1.jpg'
import img2 from './BannerImgSlider/Bannerimg2.jpg'
import img3 from './BannerImgSlider/Bannerimg3.jpg'
import img4 from './BannerImgSlider/Bannerimg4.jpg'
import img5 from './BannerImgSlider/Bannerimg5.jpg'
import Secimg1 from './BannerImgSlider/BannerSecimg2.jpg'
import Secimg2 from './BannerImgSlider/BannerSecimg1.jpg'
import Secimg3 from './BannerImgSlider/BannerSecimg3.jpg'
import Secimg4 from './BannerImgSlider/BannerSecimg4.jpg'

export const data= [img1,img2,img3,img4,img5]
export const BannerSecImages=[Secimg1,Secimg2,Secimg3,Secimg4]
